/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { eventAdminControllerCreateV1 } from '../fn/event-admin/event-admin-controller-create-v-1';
import { EventAdminControllerCreateV1$Params } from '../fn/event-admin/event-admin-controller-create-v-1';
import { eventAdminControllerDeleteV1 } from '../fn/event-admin/event-admin-controller-delete-v-1';
import { EventAdminControllerDeleteV1$Params } from '../fn/event-admin/event-admin-controller-delete-v-1';
import { eventAdminControllerFindByIdV1 } from '../fn/event-admin/event-admin-controller-find-by-id-v-1';
import { EventAdminControllerFindByIdV1$Params } from '../fn/event-admin/event-admin-controller-find-by-id-v-1';
import { eventAdminControllerSearchV1 } from '../fn/event-admin/event-admin-controller-search-v-1';
import { EventAdminControllerSearchV1$Params } from '../fn/event-admin/event-admin-controller-search-v-1';
import { eventAdminControllerUpdateStatusV1 } from '../fn/event-admin/event-admin-controller-update-status-v-1';
import { EventAdminControllerUpdateStatusV1$Params } from '../fn/event-admin/event-admin-controller-update-status-v-1';
import { eventAdminControllerUpdateV1 } from '../fn/event-admin/event-admin-controller-update-v-1';
import { EventAdminControllerUpdateV1$Params } from '../fn/event-admin/event-admin-controller-update-v-1';
import { EventDto } from '../models/event-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class EventAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `eventAdminControllerSearchV1()` */
  static readonly EventAdminControllerSearchV1Path = '/api/v1/events/admin';

  /**
   * 행사 목록 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventAdminControllerSearchV1$Response(params: EventAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<EventDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = eventAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 행사 목록 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventAdminControllerSearchV1(params: EventAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<EventDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.eventAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<EventDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<EventDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `eventAdminControllerCreateV1()` */
  static readonly EventAdminControllerCreateV1Path = '/api/v1/events/admin';

  /**
   * 행사 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventAdminControllerCreateV1$Response(params: EventAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = eventAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 행사 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventAdminControllerCreateV1(params: EventAdminControllerCreateV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.eventAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `eventAdminControllerFindByIdV1()` */
  static readonly EventAdminControllerFindByIdV1Path = '/api/v1/events/admin/{id}';

  /**
   * 행사 상세 조회 (관리자).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventAdminControllerFindByIdV1$Response(params: EventAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<EventDto>> {
    const obs = eventAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 행사 상세 조회 (관리자).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventAdminControllerFindByIdV1(params: EventAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<EventDto> {
    const resp = this.eventAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EventDto>): EventDto => r.body)
    );
  }

  /** Path part for operation `eventAdminControllerDeleteV1()` */
  static readonly EventAdminControllerDeleteV1Path = '/api/v1/events/admin/{id}';

  /**
   * 행사 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventAdminControllerDeleteV1$Response(params: EventAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = eventAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 행사 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  eventAdminControllerDeleteV1(params: EventAdminControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.eventAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `eventAdminControllerUpdateV1()` */
  static readonly EventAdminControllerUpdateV1Path = '/api/v1/events/admin/{id}';

  /**
   * 행사 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventAdminControllerUpdateV1$Response(params: EventAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = eventAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 행사 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventAdminControllerUpdateV1(params: EventAdminControllerUpdateV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.eventAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `eventAdminControllerUpdateStatusV1()` */
  static readonly EventAdminControllerUpdateStatusV1Path = '/api/v1/events/admin/{id}/status';

  /**
   * 행사 상태 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `eventAdminControllerUpdateStatusV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventAdminControllerUpdateStatusV1$Response(params: EventAdminControllerUpdateStatusV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = eventAdminControllerUpdateStatusV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 행사 상태 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `eventAdminControllerUpdateStatusV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  eventAdminControllerUpdateStatusV1(params: EventAdminControllerUpdateStatusV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.eventAdminControllerUpdateStatusV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
